// components/WhatsAppFab.js
import "./WhatsAppFab.css";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFab({
  phone = "4915905555577",
  message = "Hi Tom, I’m interested in eSIM",
}) {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return (
    <a className="wa-fab" href={url} target="_blank" rel="noopener noreferrer">
      <FaWhatsapp size={28} />
    </a>
  );
}
